import { FxPasswordInputField } from 'axp-fx-common';

export const updatePasswordFormFields = {
  password: {
    id: 'password',
    name: 'password',
    label: 'New Password',
    isRequired: true,
    additionalText: 'Generate Password',
    component: FxPasswordInputField,
  },
  confirmPassword: {
    id: 'confirmPassword',
    name: 'confirmPassword',
    label: 'Confirm Password',
    isRequired: true,
    component: FxPasswordInputField,
    className: 'col-md-3',
  },
};
